import CQ9 from "assets/images/game/fishing/fishing_CQ9.png";
import JDB from "assets/images/game/fishing/fishing_JDB.png";
import JILI from "assets/images/game/fishing/fishing_JILI.png";
import { SubGameType } from "types/game";

export const listGameFishing: SubGameType[] = [
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "JDB",
    type: "FH",
    featured: "NO",
    new_arrive: "NO",
    picture: JDB,
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "CQ9",
    type: "FH",
    featured: "NO",
    new_arrive: "NO",
    picture: CQ9,
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "JILI",
    type: "FH",
    featured: "NO",
    new_arrive: "NO",
    picture: JILI,
  },
];
